// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3RWvz","bigColWidth":"Table_bigColWidth__27bYj","biggerColWidth":"Table_biggerColWidth__3KUAc","row":"Table_row__2LPZ_","col":"Table_col__3ZgcD"};